import React from 'react';
import styles from './Footer.module.css';
import logo from '../../assets/logo.png';
import linkedinSvg from '../../assets/linkedin.svg';
import instagramSvg from '../../assets/instagram.svg';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
 
        <div className={styles.footerTop}>

          <div className={styles.logoSection}>
            <img src={logo} alt="TIA Logo" className={styles.logoImg} />
          </div>

      
          <div className={styles.quickLinks}>
            <h3>Quick Link</h3>
            <ul>
              <li><a href="https://www.tirana-airport.com/en/article/965/About-TIA" target="_blank" rel="noreferrer">About TIA</a></li>
              <li><a href="https://www.tirana-airport.com/en/article/966/Mission-%26-Vision" target="_blank" rel="noreferrer">Values</a></li>
              <li><a href="https://www.tirana-airport.com/en/articles" target="_blank" rel="noreferrer">News</a></li>
            </ul>
          </div>

          <div className={styles.contactSocial}>
            <div className={styles.contact}>
              <h3>HR Contact Email:</h3>
              <a href="mailto:human.resources@tirana-airport.com">
                human.resources@tirana-airport.com
              </a>
            </div>
            <div className={styles.social}>
              <h3>Follow Us On</h3>
              <div className={styles.socialIcons}>
                <a href="https://www.linkedin.com/company/tirana-international-airport" target="_blank" rel="noreferrer">
                  <img src={linkedinSvg} alt="LinkedIn" className={styles.socialIconImg} />
                </a>
                <a href="https://www.instagram.com/tirana.international.airport/" target="_blank" rel="noreferrer">
                  <img src={instagramSvg} alt="Instagram" className={styles.socialIconImg} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className={styles.footerBottom}>
          <p>© 2025 Tirana International Airport. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
